import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActivityInternal, GungModalService } from 'gung-standard';
import { CultActivityInternalCreateModalComponent } from '../components/cult-activity-internal-create-modal/cult-activity-internal-create-modal.component';
import { CultActivityInternalViewModalComponent } from '../components/cult-activity-internal-view-modal/cult-activity-internal-view-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CultGungModalService extends GungModalService {
  openCreateActivityModal(
    activity?: ActivityInternal,
    modalOption?: NgbModalOptions,
    customerId?: string
  ): Promise<any> {
    const id = CultActivityInternalCreateModalComponent.name;

    const option: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
      // windowClass: 'modal-lg-custom',
      ...modalOption
    };
    const ref = this.ngbModal.open(CultActivityInternalCreateModalComponent, option);
    ref.componentInstance.activity = activity;
    ref.componentInstance.customerId = customerId;
    this.modalRef.set(id, ref);
    return ref.result;
  }

  openViewActivityModal(
    activity: ActivityInternal,
    modalOption?: NgbModalOptions
  ): Promise<any> {
    const id = CultActivityInternalViewModalComponent.name;

    const option: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      ...modalOption
    };
    const ref = this.ngbModal.open(CultActivityInternalViewModalComponent, option);
    ref.componentInstance.data = activity;
    this.modalRef.set(id, ref);
    return ref.result;
  }
}
